<template>
  <div class="screenshots-manager p-grid">
    <div v-for="user in Object.keys(latest)" :key="user" class="p-col-4">
      <header class="p-d-flex">
        <div class="username p-flex p-d-flex-grow-1">
          {{mapName(user)}}
        </div>
        <div class="p-flex-initial p-flex">
          <screenshot-request-button :user="user" />
        </div>
      </header>
      <div class="screenshot2">
        <expandable-image :src="latest[user].url" :close-on-background-click="true" />
        <footer class="p-d-flex">
          <div class="timestamp p-flex-initial p-flex">
            <timeago :datetime="latest[user].createdAt" :auto-update="60"></timeago>
          </div>
          <div class="page p-flex p-d-flex-grow-1">
            {{latest[user].page}}
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import ScreenshotRequestButton from './ScreenshotRequestButton'
import config from '../../config/config.json'

export default {
  name: 'ScreenshotsManager',
  components: {
    ScreenshotRequestButton
  },
  props: {
    perRow: {
      type: Number,
      default: 3
    }
  },
  async created () {
    this.$store.dispatch('screenshots/loadInitial')
  },
  computed: {
    all () {
      return this.$store.getters['screenshots/all']
    },
    latest () {
      return this.$store.getters['screenshots/latest']
    },
    additionalColumnsCount () {
      const excess = this.latest % this.perRow
      return excess
    }
  },
  methods: {
    requestFromUser (user) {
      this.$store.dispatch('screenshots/request', user)
    },
    mapName (username) {
      const name = config.screens[username]
      if (name !== null && name !== undefined && name !== '') {
        return `${name} (${username})`
      }
      return username
    }
  }
}
</script>

<style scoped>
header {
  margin-bottom: 5px;
}
.screenshot2 .expandable-image {
  border: solid 1px #ccc;
}
.screenshot {
  position: relative;
}
.screenshot .username, .screenshot img, .screenshot .timestamp {
  position: absolute;
}
.screenshot .timestamp {
  bottom: 0;
  right: 0;
}
img {
  max-width: 100%;
}
.username {
  flex: 1;
  font-weight: bold;
}
footer {
  margin-top: 5px;
}
.page {
  flex: 1;
  text-align: right;
}
.timestamp, .page {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/screenshots/ScreenshotsManager.vue